// extracted by mini-css-extract-plugin
export default {"section":"Support_section__YzV4z","question":"Support_question__KNTmA"};